/** @jsx jsx */
import React from "react"
import { jsx } from "@emotion/core"
import { SecondaryAction } from "./SecondaryAction"
import { PrimaryAction } from "./PrimaryAction"
import { ContentArea } from "./ContentArea"
import { colors, flex, typography } from "../styles"

export const Footer = props => {
  return (
    <footer
      css={{
        backgroundColor: colors.DARK_GRAY,
        fontFamily: typography.UNIVIA,
        padding: "5%",
        fontSize: "0.75rem",
        textAlign: "center",
        lineHeight: 1.4,
      }}
    >
      <ContentArea
        css={[
          {
            ...flex("column"),
            alignItems: "center",
            justifyContent: "center",

            height: "100%",
            color: colors.MID_GRAY,
          },
        ]}
      >
        {/* <h2 css={{ color: colors.BLUE, fontWeight: 100 }}>
          Our site is under construction...
        </h2>
        <br />
        <p css={{ color: "inherit" }}>
          For assistance or information, please contact us. You'll hear directly
          from a member of our team.
        </p>
        <br />
        <SecondaryAction
          href={"mailto:info@mysticparker.com"}
          css={{ backgroundColor: colors.LIGHT_GRAY }}
        >
          info@mysticparker.com
        </SecondaryAction>
        <br />
        <span css={{ color: colors.MID_GRAY }}>&mdash; or &mdash;</span>
        <br />
        <PrimaryAction href={"tel:7813214948"}>781-321-4948</PrimaryAction>
        <br /> */}
        Design. Print. Promote. <br />
        <address>66 Willow Street, Malden, MA 02148</address>
        Copyright &copy; {new Date().getFullYear()} Mystic Parker Printing
      </ContentArea>
    </footer>
  )
}

export default Footer
